import { toast } from 'react-toastify';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { getTranslation } from '../../utils/get-translation.util';
import { useAppMutation } from '../use-app-mutation.hook';
import { useInvalidateQueries } from '../use-invalidate-queries.hook';
import { DIVIDEND_INVALIDATION_KEYS } from './dividend-invalidation.const';

type UpdateDateDto = {
  approvalDate?: null | string;
  id: string;
  payoutDate?: null | string;
};

export const useDividendUpdateDate = () => {
  const { invalidateQuery } = useInvalidateQueries(...DIVIDEND_INVALIDATION_KEYS);

  const { isPending, mutate: updateDate } = useAppMutation<unknown, unknown, UpdateDateDto>(
    [QueryKey.UPDATE_DIVIDEND_DATE],
    {
      mutationFn: ({ id, approvalDate, payoutDate }) =>
        ApiService.patch(
          { endpoint: BackendRoute.DIVIDENDS, routePath: [id] },
          { body: { approvalDate, payoutDate } },
        ),
      onSuccess: () => {
        invalidateQuery();
        toast.success(getTranslation('PAYOUT_STATUS_UPDATED_SUCCESS'));
      },
    },
  );

  return { isPending, updateDate };
};
